import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {AssetService} from "../../services/AssetService";
import {Asset} from "../../entities/Asset";

export class CmdCenterShowNearestModel {
    static $inject = ['$q','AssetService','CustomFieldNameService','NotificationService'];
    assetColumnDefs:[string,string,number][];
    assets:Asset[] = [];
    constructor(public $q:ng.IQService,
                public assetService:AssetService,
                public customFieldNameService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }
    init(vtagId:string){
        return this.$q.all([this.assetService.getFixedChildren(vtagId),this.customFieldNameService.getAssetColumnDefs()])
            .then((data)=>{
                this.assets = data[0];
                this.assetColumnDefs = data[1];
                return this.$q.when();
            });
    }
}
